import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation resources
import fr from './bundle/fr.json';
import ar from './bundle/ar.json';

const resources = {
  fr: {
    translation: fr,
  },
  ar: {
    translation: ar,
  },
};

const savedLanguage = localStorage.getItem('myLanguage') || 'fr';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: savedLanguage,
    fallbackLng: 'fr',
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  });

export default i18n;
